import { useEffect, useRef, useState } from 'react'
import * as d3 from 'd3'
// import './worldmapTooltip.css'
import { COLOR_MAP } from '../../../common/utils/theme'
import MapLegend from './MapLegend'
import './worldmapTooltip.css'
import { getColorScale } from '../../../common/utils/helper'

const WorldMap = ({
  handleTooltipClick,
  features,
  selectedTab,
  selectedValue,
}) => {
  let svg, path, zoom, tooltip
  let width = 800
  let height = 450

  const worldMapContainerRef = useRef(null)
  const worldmapSvgRef = useRef(null)
  const [mapWidth, setMapWidth] = useState(width)
  const [mapHeight, setMapHeight] = useState(height)

  const [selectedCountryData, setSelectedCountryData] = useState(null)

  useEffect(() => {
    const containerWidth = worldMapContainerRef?.current?.offsetWidth
    if (containerWidth) {
      setMapWidth(containerWidth)
      setMapHeight(containerWidth / 2)
    }
  }, [])

  useEffect(() => {
    if (features && selectedValue) {
      drawMap(features)
    }
  }, [features, mapWidth, mapHeight, selectedValue])

  const drawMap = (features) => {
    let mapProjection = d3
      .geoNaturalEarth1()
      .scale((mapWidth / 580) * 100)
      .translate([mapWidth / 2, mapHeight / 2])
    path = d3.geoPath().projection(mapProjection)
    const graticule = d3.geoGraticule()
    d3.select('body')
      .selectAll('div.worldmap-tooltip')
      .style('visibility', 'hidden')
    svg = d3.select('#worldmapSvg')
    svg.selectAll('*').remove()

    svg
      .append('path')
      .datum(graticule.outline)
      .attr('class', 'foreground')
      .attr('d', path)
      .attr('fill', COLOR_MAP.mapBackground)

    var g = svg
      .append('g')
      .selectAll('path')
      .data(features)
      .enter()
      .append('path')
      .attr('d', path)
      .style('stroke', 'black')
      .style('stroke-width', '0.15')
      .attr('class', 'country')
      .style('cursor', (d) => {
        return d.properties.value !== '' &&
          d.properties.value !== undefined &&
          d.properties.value !== 'No Data' &&
          d.properties.value !== null
          ? 'pointer'
          : 'default'
      })
      .attr('fill', (d) => {
        return getColorScale
          ? d.properties.value !== '' &&
            d.properties.value !== undefined &&
            d.properties.value !== 'No Data' &&
            d.properties.value !== null
            ? getColorScale(d.properties.value)
            : COLOR_MAP.noData
          : COLOR_MAP.noData
      })
      .style('opacity', 1)
      .on('mouseover', function (d) {
        // d3.selectAll(".country").transition().duration(200).style("opacity", 0.5);
        d3.select(this)
          .transition()
          .duration(200)
          .style('stroke', 'black')
          .style('stroke-width', 1.5)
          .style('vector-effect', 'non-scaling-stroke')

        // d3.select('body').selectAll('div.worldmap-tooltip').remove()

        // // tooltip position set relative to tui__chart_content
        // tooltip = d3
        //   .select('#world_map')
        //   .append('div')
        //   .attr('class', 'worldmap-tooltip')
        //   .html(getTooltipContent(d))
        //   .style('visibility', 'visible')
      })
      .on('click', function (d) {
        d3.select('body')
          .selectAll('div.worldmap-tooltip')
          .style('visibility', 'hidden')
        setSelectedCountryData(d.properties)
        if (
          d.properties.value === '' ||
          d.properties.value === null ||
          d.properties.value === undefined
        ) {
        } else {
          const transform = d3.zoomTransform(svg.node())
          const [mouseX, mouseY] = d3.mouse(this)
          const adjustedMouseX = transform.applyX(mouseX)
          const adjustedMouseY = transform.applyY(mouseY)
          tooltip = d3
            .select('#worldmap-tooltip')
            .style('visibility', 'visible')
            .style('left', `${adjustedMouseX - 235}px`)
            .style('top', `${adjustedMouseY + 25}px`)
        }
      })
      .on('mouseleave', function (d) {
        d3.selectAll('.country').transition().duration(200).style('opacity', 1)
        d3.select(this).transition().duration(10).style('stroke', 'none')
        d3.select(this)
          .transition()
          .duration(10)
          .style('stroke', 'black')
          .style('stroke-width', '0.15')
          .style('vector-effect', 'non-scaling-stroke')
      })

    // Zoom functionality -- start
    zoom = d3
      .zoom()
      .scaleExtent([0.5, 4])
      .on('zoom', function () {
        g.attr('transform', d3.event.transform)
      })
    svg.call(zoom)

    const handleZoomIn = () => {
      zoom.scaleBy(
        d3.select(worldmapSvgRef.current).transition().duration(750),
        2
      )
    }
    const handleZoomOut = () => {
      zoom.scaleBy(
        d3.select(worldmapSvgRef.current).transition().duration(750),
        0.5
      )
    }
    d3.select('#zoomInBtn').on('click', handleZoomIn)
    d3.select('#zoomOutBtn').on('click', handleZoomOut)
    // Zoom functionality -- end

    // d3.select('svg').on('click', function () {
    //   const x = d3.select(this)
    //   console.log('test')
    // })
  }
  return (
    <>
      {selectedValue && (
        <div className="zoom-button-container download-exclude">
          <div className="zoom-in-icon" id="zoomInBtn">
            <span className="lp lp-plus"></span>
          </div>
          <div className="zoom-out-icon" id="zoomOutBtn">
            <span className="lp lp-minus"></span>
          </div>
        </div>
      )}
      <div
        id="world_map"
        ref={worldMapContainerRef}
        style={{ background: COLOR_MAP.mapBackground }}
      >
        <svg
          id="worldmapSvg"
          className="map"
          width={mapWidth}
          height={mapHeight}
          ref={worldmapSvgRef}
        ></svg>
        {selectedValue && (
          <div className="worldmap-tooltip" id="worldmap-tooltip">
            <a
              href="#closetooltip"
              className="close-window"
              onClick={(event) => {
                event.preventDefault()
                d3.select('body')
                  .selectAll('div.worldmap-tooltip')
                  .style('visibility', 'hidden')
              }}
            >
              <span className="sr-only">Close window</span>
            </a>
            <div className="tooltip-top">
              {' '}
              <span className="tooltip-country" id="tooltip-country">
                {selectedCountryData
                  ? `${selectedCountryData.country_na} `
                  : ''}
              </span>
              <span className="tooltip-year" id="tooltip-selected-tab">
                {' '}
                {selectedValue}
              </span>
            </div>
            {selectedTab === 'topic' ? 'Topic Score' : 'Pillar Score'}
            <div className="tooltip-bottom">
              {' '}
              {selectedCountryData &&
              selectedCountryData.value !== null &&
              selectedCountryData.value !== undefined &&
              selectedCountryData.value !== '' ? (
                <span className="tooltip-value" id="tooltip-value">
                  {selectedCountryData.value}
                </span>
              ) : (
                <span>Data not available</span>
              )}
            </div>
            <div>
              <button
                onClick={() => handleTooltipClick(selectedCountryData.iso3)}
              >
                Economy details
              </button>
            </div>
          </div>
        )}
      </div>
      {selectedValue && <MapLegend />}
    </>
  )
}
export default WorldMap
